module.exports = __webpack_public_path__ + "fox5.png";